import { store } from "../../../store/GlobalStore.ts";
import { ChatBotModel } from "./ChatBotModel.ts";
import { getChatbotData } from '../../../../apiclients/streamsapi_bridge.js';
import { addMessage, clearChatBotStore, setReceiverLoader, setTypingMessageEffect, deleteMessageFromStore , userMessageReceived} from "../store/ChatBotStore.ts";
import ChatDB from './chatDB.js'

const TAG = '[ChatBotHelper]';

export class ChatBotHelper {

    private static instance: ChatBotHelper;

    constructor() {

    }

    public static getInstance(): ChatBotHelper {
        if (!ChatBotHelper.instance) {
            this.instance = new ChatBotHelper()
        }

        return ChatBotHelper.instance;
    }

    sendMessage(text: string, connectionType: string) {

        const userMsg: ChatBotModel = {
            sender: "user",
            text: text.trim(),
            time: new Date().toLocaleTimeString(),
            chatid: Date.now(),
            isMsgReceived: false,
        };

        store.dispatch(addMessage({ msg: userMsg, type: 'user' }));
        this.sendRequestForChatBotQuestion(connectionType, userMsg);
    }


    retryFailedMessage(model: ChatBotModel, connectionType: string) {
        try {

            store.dispatch(deleteMessageFromStore(model.chatid)); // Remove from Redux store
            this.sendMessage(model.text.trim(), connectionType);
        } catch (e) {
            console.log('[retryFailedMessage] Error ::' + e);
        }
    }

    receiveBotReply(text: string, chatId: number) {

        const botReply: ChatBotModel = {
            sender: "bot",
            text: text.trim(),
            time: new Date().toLocaleTimeString(),
            chatid: chatId,
        };

        store.dispatch(addMessage({ msg: botReply, type: 'bot' }));
    }

    async sendRequestForChatBotQuestion(connectionType: string, userMsg: ChatBotModel) {
        try {

            if (!navigator?.onLine) {// Check if the Internet is available or not
                store.dispatch(setReceiverLoader(false));
                return;
            }

            let sessionDataRaw = sessionStorage.getItem("admin_session");
            let sessionData: any = {};
            if (sessionDataRaw) {
                try {
                    sessionData = JSON.parse(sessionDataRaw);
                } catch (e) {
                    console.error("Failed to parse sessionData:", e);
                }
            }

            const { logined_user, siteid, loginusername, mailId, dealerid } = sessionData;

            let params = {
                "question": userMsg.text,
                "module": connectionType.toLocaleLowerCase(),
                "chatid": userMsg.chatid,
                logined_user,
                siteid,
                loginusername,
                mailId,
                dealerid
            }

            console.log("[sendRequestForChatBotQuestion] params :: " + JSON.stringify(params));

            let response: any;
            try {
                response = await this.serverResponseTimeout(getChatbotData(params), 180000);
                console.log('response for chatbot ::'+ JSON.stringify(response))
            } catch (err) {
                console.error("Timeout or network error:", err);
                store.dispatch(setReceiverLoader(false));
                return;
            }

            let chatbotData = await response.json();
            console.log("[sendRequestForChatBotQuestion] chatbotData :: " + JSON.stringify(chatbotData));   
            if (Number(response?.status) == 200) {

                this.receiveBotReply(chatbotData?.response_data, chatbotData?.request_params?.chatid);

            } else {

                store.dispatch(setReceiverLoader(false));
            }

        } catch (e) {
            console.log(TAG + "[sendRequestForChatBotQuestion] Exception:: " + e);
        }
    }


    async serverResponseTimeout(request: Promise<Response>, timeoutMs: number): Promise<Response>{
        return new Promise((resolve, reject) =>{
            const timer = setTimeout(() =>reject(new Error("Request timed out")), timeoutMs);

            request
                .then((res) =>{
                    clearTimeout(timer);
                    resolve(res);
                })
                .catch((err) =>{
                    clearTimeout(timer);
                    reject(err);
                });
        });
    }

    clearChatBotHistory() {
        try {

            store.dispatch(clearChatBotStore())
            ChatDB.clearChatBotDatabase();

        } catch (e) {
            console.log(TAG + "[clearChatBotHistory] Exception:: " + e);
        }
    }

    autoLinkifyMarkdown(text: string) {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, (url) => `[${url}](${url})`);
    }
}